window.siteLanguage = (function () {
  const lang = document.documentElement.lang;
  if (lang.startsWith("zh")) {
    return "zh";
  }
  return lang || "en";
})();

window.locales = {
  en: {
    gpu_avl_title: "Compatible GPU AVL",
  },
  ja: {
    gpu_avl_title: "対応GPU AVL",
  },
  de: {
    gpu_avl_title: "Kompatible GPU AVL",
  },
  zh: {
    gpu_avl_title: "相容的 GPU AVL",
  },
  es: {
    gpu_avl_title: "AVL de GPU compatible",
  },
};

window.getLocaleText = function (key) {
  return window.locales[window.siteLanguage][key] || window.locales["en"][key] || key;
};

function updateLocalizedLinks() {
  if (window.siteLanguage !== "en") {
    var links = document.querySelectorAll("a[href]");
    var currentHost = window.location.hostname;

    links.forEach(function (link) {
      var href = link.getAttribute("href");
      if (!href || href.startsWith("#") || href.startsWith("mailto:") || href.startsWith("tel:")) {
        return;
      }

      try {
        var url = new URL(href, window.location.origin);

        if (url.hostname === currentHost || url.hostname === "premioinc.com") {
          var path = url.pathname;
          var langPrefix = "/" + window.siteLanguage + "/";

          if (!path.startsWith(langPrefix) && path !== "/" + window.siteLanguage) {
            var newPath = "/" + window.siteLanguage + (path.startsWith("/") ? path : "/" + path);
            link.href = newPath + url.search + url.hash;
          }
        }
      } catch (e) {
        // Ignore potentially invalid URLs
      }
    });
  }
}

window.addEventListener("DOMContentLoaded", updateLocalizedLinks);
window.addEventListener("load", updateLocalizedLinks);
